/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsFilter } from './ContactDetailsFilter';
import {
    ContactDetailsFilterFromJSON,
    ContactDetailsFilterFromJSONTyped,
    ContactDetailsFilterToJSON,
} from './ContactDetailsFilter';
import type { TrendInterval } from './TrendInterval';
import {
    TrendIntervalFromJSON,
    TrendIntervalFromJSONTyped,
    TrendIntervalToJSON,
} from './TrendInterval';

/**
 * 
 * @export
 * @interface GetPromptTrendAnalyticsWithFiltersRequestContent
 */
export interface GetPromptTrendAnalyticsWithFiltersRequestContent {
    /**
     * 
     * @type {string}
     * @memberof GetPromptTrendAnalyticsWithFiltersRequestContent
     */
    questionId: string;
    /**
     * 
     * @type {TrendInterval}
     * @memberof GetPromptTrendAnalyticsWithFiltersRequestContent
     */
    interval: TrendInterval;
    /**
     * Return analytics on contacts created before this timestamp
     * @type {string}
     * @memberof GetPromptTrendAnalyticsWithFiltersRequestContent
     */
    from?: string;
    /**
     * Return analytics on contacts after this timestamp
     * @type {string}
     * @memberof GetPromptTrendAnalyticsWithFiltersRequestContent
     */
    to?: string;
    /**
     * 
     * @type {Array<ContactDetailsFilter>}
     * @memberof GetPromptTrendAnalyticsWithFiltersRequestContent
     */
    filters?: Array<ContactDetailsFilter>;
}


/**
 * Check if a given object implements the GetPromptTrendAnalyticsWithFiltersRequestContent interface.
 */
export function instanceOfGetPromptTrendAnalyticsWithFiltersRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "questionId" in value;
    isInstance = isInstance && "interval" in value;

    return isInstance;
}

export function GetPromptTrendAnalyticsWithFiltersRequestContentFromJSON(json: any): GetPromptTrendAnalyticsWithFiltersRequestContent {
    return GetPromptTrendAnalyticsWithFiltersRequestContentFromJSONTyped(json, false);
}

export function GetPromptTrendAnalyticsWithFiltersRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromptTrendAnalyticsWithFiltersRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'interval': TrendIntervalFromJSON(json['interval']),
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(ContactDetailsFilterFromJSON)),
    };
}

export function GetPromptTrendAnalyticsWithFiltersRequestContentToJSON(value?: GetPromptTrendAnalyticsWithFiltersRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'questionId': value.questionId,
        'interval': TrendIntervalToJSON(value.interval),
        'from': value.from,
        'to': value.to,
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(ContactDetailsFilterToJSON)),
    };
}

